"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckOpenAccountRequest = void 0;
var CheckOpenAccountRequest = /** @class */ (function () {
    function CheckOpenAccountRequest() {
    }
    return CheckOpenAccountRequest;
}());
exports.CheckOpenAccountRequest = CheckOpenAccountRequest;
;
//# sourceMappingURL=checkOpenAccount.request.js.map